<div class="modal-vdp-container">
  <div class="header-content">
    <button
      (click)="selecionarModo('resumo-bci')"
      class="btn btn-light btn-md"
      [ngClass]="{ 'active-btn': modoSelecionado === 'resumo-bci' }"
    >
      Resumo VDP/BCI
    </button>
    <button
      (click)="selecionarModo('resumo-abr')"
      class="btn btn-light btn-md"
      [ngClass]="{ 'active-btn': modoSelecionado === 'resumo-abr' }"
    >
      Resumo VDP/ABR
    </button>
  </div>

  <div *ngIf="modoSelecionado === 'resumo-bci'" class="px-2 w-100">
    <app-modal-notas
      title="Resumo da VDP/BCI (%)"
      [unidadeProdutiva]="unidadeProdutiva"
      [containerNota]="containerNota.notasVdpBci"
      [modal]="modal"
    ></app-modal-notas>
  </div>

  <div *ngIf="modoSelecionado === 'resumo-abr'" class="px-2 w-100">
    <app-modal-notas
      title="Resumo da VDP/ABR (%)"
      [unidadeProdutiva]="unidadeProdutiva"
      [containerNota]="containerNota.notasVdpAbr"
      [modal]="modal"
    ></app-modal-notas>
  </div>

  <div class="modal-footer footer-content-responsive mt-4">
    <button type="button" class="btn btn-light" (click)="onClose()">
      Fechar
    </button>
  </div>
</div>
